module.exports = __webpack_public_path__ + "media/kas.37a9c8c2.mp4";